import Glide, { Controls } from "@glidejs/glide/dist/glide.modular.esm";

var Slider = {
  init: function () {
    const config = {
      type: "carousel",
      startAt: 0,
      perView: 1,
      gap: 0,
      peek: { before: 0, after: 0 },
    };

    var glides = document.querySelectorAll(".glide");
    for (var i = 0; i < glides.length; i++) {
      new Glide(glides[i], config).mount({ Controls });
    }
  },
};

export default Slider;
